<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 3.05C12 2.4701 11.5299 2 10.95 2L1.05 2C0.470101 2 -2.05488e-08 2.4701 -4.5897e-08 3.05C-7.12451e-08 3.6299 0.4701 4.1 1.05 4.1L10.95 4.1C11.5299 4.1 12 3.6299 12 3.05ZM12 8.95039C12 8.37049 11.5299 7.90039 10.95 7.90039L1.05 7.90039C0.470101 7.90039 -2.78463e-07 8.37049 -3.03811e-07 8.95039C-3.29159e-07 9.53029 0.4701 10.0004 1.05 10.0004L10.95 10.0004C11.5299 10.0004 12 9.53029 12 8.95039Z"
    fill="currentColor"
  />
</template>
